import { apiFetch } from './interceptor';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/v1';

export const settingsApi = {
  // post: settings
  settings: async (token, userId, key, value, otherSettings) => {
    const response = await apiFetch(`${BASE_URL}/settings`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ userId, key, value, otherSettings })
    });
    const data = await response.json();
    return { status: response.status, data };
  },

  // get: settings
  getSettings: async (token, userId, key) => {
    const response = await apiFetch(`${BASE_URL}/settings?userId=${userId}&key=${key}`, {
      headers: { 'Authorization': `Bearer ${token}` },
      method: 'GET',
    }, false);
    const data = await response.json();
    return { status: response.status, data };
  },

  getSettingsByKey: async (token, key) => {
    const response = await apiFetch(`${BASE_URL}/settings/glo?key=${key}`, {
      headers: { 'Authorization': `Bearer ${token}` },
      method: 'GET',
    }, false);
    const data = await response.json();
    return { status: response.status, data };
  },
};

